import { RadioGroup } from "@vidstack/react";
import { CheckIcon } from "@vidstack/react/icons";
import ReactCountryFlag from "react-country-flag";
import React from "react";
import { LanguageTrackList } from "@/components/player/language/LanguageTrack";
export default function LanguageMenuContent({
  languageTracks,
  selectedLanguage,
  onLanguageChange,
  displayFlags
}: {
  languageTracks: LanguageTrackList;
  selectedLanguage: string;
  onLanguageChange: (lang: string) => void;
  displayFlags: boolean;
}) {
  return <>
            <RadioGroup.Root className="vds-radio-group" aria-label="Language Options" value={selectedLanguage} data-sentry-element="unknown" data-sentry-source-file="LanguageMenuContent.tsx">
                {languageTracks.map(option => <RadioGroup.Item className="vds-radio" key={option.languageCode} value={option.languageCode} onClick={() => onLanguageChange(option.languageCode)}>
                        <CheckIcon className="vds-icon" />
                        {option.countryCode && displayFlags ? <ReactCountryFlag className="vds-radio-label flag" countryCode={option.countryCode} svg /> : null}
                        <span className="vds-radio-label">{option.nativeLabel}{option.languageCode ? ` (${option.languageCode})` : ''}</span>
                    </RadioGroup.Item>)}
            </RadioGroup.Root>
        </>;
}